import { render, staticRenderFns } from "./WatchGallery.vue?vue&type=template&id=38227099&lang=html&"
import script from "./WatchGallery.vue?vue&type=script&lang=js&"
export * from "./WatchGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports